import { Collection } from 'es6/components/collection'
import { Discount } from 'es6/models/discount'
import { Defaults } from 'es-decorators'

/**
 * Типы доставки
 */
@Defaults({
  model: Discount,
})
export class Discounts extends Collection {}
